"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const QuestionnaireTypes_1 = require("../../../Enum/QuestionnaireTypes");
const PXWidgetState_1 = require("../../../Extendables/PXWidgetState");
class ViewWidgetState extends PXWidgetState_1.default {
    setAnsweredQuestionnaire(questionnaire, answeredQuestionnaire) {
        const currentState = this.get('questionnaires') || {};
        const type = Object.entries(QuestionnaireTypes_1.QuestionnaireTypes)
            .find((arr) => arr[1] === questionnaire.getMachineName())[0];
        currentState[type] = {
            questionnaire: questionnaire,
            answers: answeredQuestionnaire
        };
        this.set(`questionnaires`, currentState);
        return this;
    }
}
exports.default = ViewWidgetState;
